import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { ZFilterTemplate } from "../../types";

type Params = {
  onDelete: (row: ZFilterTemplate) => void;
};

export const queryBuilderTemplatesColumns = (
  params: Params,
): RtColumn<ZFilterTemplate>[] => [
  {
    title: "Название",
    key: "name",
    render: ({ name }) => name,
  },
  {
    title: "Описание",
    key: "description",
    render: ({ description }) => description,
  },
  {
    title: "",
    key: "actions",
    width: 60,
    render: (row) => (
      <Button
        type="text"
        icon={<DeleteOutlined />}
        onClick={() => params.onDelete(row)}
      />
    ),
  },
];
